<template>
<div>
    <BreadCrumb class="bread" :breads="['系统管理', '登陆管理']"></BreadCrumb>
    <div class="wrap" element-loading-text="加载中">
        <div class="header">
            <span class="nameFt">登陆管理</span>
        </div>
        <div class="submit-form">
            <el-form ref="form" :inline="true" size="small" label-width="100px">
                <div class="submit-form__search">

                    <el-form-item label="登陆人" >
                        <el-input v-model="search.name"></el-input>
                    </el-form-item>

                    <el-form-item label="登陆人手机" prop="status">
                        <el-input v-model="search.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="设备名称" prop="status">
                        <el-input v-model="search.device_name"></el-input>
                    </el-form-item>
                    <el-form-item label="版本号" prop="status">
                        <el-input v-model="search.version"></el-input>
                    </el-form-item>
                    <el-form-item label="在线状态" prop="login_status">
                      <el-select v-model="search.login_status">
                <el-option value="1" label="正常"></el-option>
                <el-option value="2" label="下线"></el-option>
                <el-option value="3" label="到期"></el-option>
              </el-select>
                        <!-- <el-input v-model="search.hard_number"></el-inpu
                          t> -->
                    </el-form-item>

                </div>
                <div class="submit-form__operate">
                    <el-form-item>
                        <el-button type="primary" class="operate-button" @click="searchForm">查询</el-button>
                        <el-button type="primary" class="operate-button" @click="reset">重置</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="operate-con">
            <el-button size="small" @click="exportExcel" :disabled="tableList.length === 0">导出</el-button>
            <!-- <el-radio v-model="radio" class="radio" label="30">保留一个月数据</el-radio> -->
        </div>
        <div class="table-con">
            <el-table :data="tableList" stripe v-loading="loading">
                <el-table-column label="序号" :index="indexMethod" type="index" align="center"></el-table-column>
                <el-table-column label="登录人" prop="name" align="center"></el-table-column>
                <el-table-column label="登录人手机" prop="phone" align="center"></el-table-column>
                <el-table-column label="设备名称" prop="device_name" align="center"></el-table-column>
                <el-table-column label="版本号" prop="version" align="center"></el-table-column>
                <el-table-column label="登陆状态" prop="operation_type" align="center">
                    <div slot-scope="scope">
                        <div v-if="scope.row.login_status == 1">正常</div>
                        <div v-if="scope.row.login_status == 2">下线</div>
                        <div v-if="scope.row.login_status == 3">到期</div>
                    </div>
                </el-table-column>
                <el-table-column label="登陆时间" prop="login_time" align="center"></el-table-column>
                <el-table-column label="最后访问时间" prop="last_time" align="center"></el-table-column>
                <el-table-column label="有效期至" prop="active_time" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="250px">
                    <div slot-scope="scope">
                        <el-button size="mini" type="primary" @click="downOffline(scope.row.id)"  v-if="scope.row.login_status == 1">强制下线</el-button>
                    </div>
                </el-table-column>
            </el-table>
        </div>
        <div class="paginationWrap">
            <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum" :layout="pageLayout" :total="total">
            </el-pagination>
        </div>
    </div>
</div>
</template>

  
  
<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import listMixin from "@/mixins/list";
import alert from "@/plugins/alert";
import {
    orderStatus
} from "@/plugins/enum";
import {
    pickerOptions
} from "@/plugins/enum";
import {
    download
} from "@/plugins/util";
import authority from '@/store/modules/authority';
export default {
    name: "CustomerManagement",
    data() {
        return {
            search: {
                name: "",
                phone: "",
                device_name: "",
                version:"",
                login_status:"",
                user_id: localStorage.getItem('user_id'),

            },
            pickerOption: pickerOptions,
            time: [],

            radio: "30",
            operation_terminal: {
                "": "全部",
                PC: "PC后台",
                HARDWARE: "硬件操作",
                TERMINAL: "机器端"
            },
            importance: {
                "": "全部",
                IMPORTANT: "重要",
                MEDIUM: "中等",
                GENERAL: "一般",
            },
        };
    },
    mixins: [listMixin],
    created() {
        this.search = Object.assign(this.search, this.$route.query);
        this.getData();
    },
    watch: {
        // time: function (val) {
        //   if (val) {
        //     this.search.start_time = val[0];
        //     this.search.end_time = val[1] + " 23:59:59";
        //   } else {
        //     this.search.start_time =
        //       dateFormat("yyyy-MM-dd", new Date()) + " 00:00:00";
        //     this.search.end_time =
        //       dateFormat("yyyy-MM-dd", new Date()) + " 23:59:59";
        //   }
        // },
        time: function (val) {
            if (val) {
                this.search.start_time = val[0];
                this.search.end_time = val[1];
            } else {
                this.search.start_time = ""
                this.search.end_time = ""

            }
        },
    },
    methods: {
        getData() {

            const token = localStorage.getItem('token');
            const headers = {
                'Authorization': `Basic ${token}`
            };
            this.getTableData(apis.get_login_management, "get", this.search);
        },
        searchForm() {
            this.search.page_index = 1;
            this.getData();
        },
        reset() {
            this.search.page_index = 1;
            this.search = {
                operation_terminal: "",
                importance: "",
            };
            this.time = [];
            this.getData();
        },
        openView(id) {
            this.$router.push({
                name: "logDetail",
                query: {
                    id: id,
                },
                params: this.search,
            });
        },
          exportExcel() {
            let _search = Object.assign(this.search, {
                export: true,
            });
            download(this, apis.get_login_management, "登陆管理.csv", "get", _search);
        },
        downOffline(id) {
            alert.offlineAlertDown().then((res) => {
                this.$axios.get(apis.force_offline + "/" + id+'/').then((res) => {
                    if (res.data.code === 200) {
                        this.getData();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                        });
                    }
                });
            });
        },
    },
    components: {
        BreadCrumb,
    },
};
</script>
  
  
<style lang="scss" scoped>
.operate-con {
    .radio {
        float: right;
        top: 10px;
        right: 10px;
    }
}
</style>
